module.exports = __webpack_public_path__ + "img/icon-5.091fa402.png";